import { useQuery } from '@tanstack/react-query';
import { makeRemoteGetIsSiteAdmin } from 'main/factories/usecases/get-is-site-admin';

export const useGetIsSiteAdmin = (userId: string | undefined) => {
  return useQuery({
    queryKey: ['isSiteAdmin', userId],
    queryFn: async () => {
      const service = makeRemoteGetIsSiteAdmin();
      return service.getIsSiteAdmin({ userId: userId! });
    },
    staleTime: 1000 * 60 * 5,
    enabled: !!userId,
  });
};
